import { ThemeOption } from '@helpers/brand';
import { withBaseProps } from '@hoc/withBaseProps';
import LatestArticles from '@stories/Widgets/Aggregation/LatestArticles/LatestArticles';
import * as React from 'react';
import S from './MediaArticleIntro.styles';
const MediaArticleIntro = (props) => {
    return (React.createElement(S.Container, { id: props.id },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } })),
            React.createElement(S.MediaColumn, null, props.articles &&
                React.createElement(LatestArticles, { title: props.articleTitle ? props.articleTitle : 'Related Articles', items: props.articles, singleSlide: true, theme: ThemeOption.Default, cta: props.articleCta })))));
};
export default withBaseProps(MediaArticleIntro);
